<template>
    <div>
        <div class="row">
            <input-select class="col-12 col-md-6" label="Pessoa" :options="pessoas" v-model="pessoa"/>
            <input-select class="col-12 col-md-6" label="Projeto" :options="projetos" v-model="projeto"/>
            
            <input-select class="col-12 col-md-3" :min="1998" :label="'Ano inicial'" :options="anos" v-model="anoInicial"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" label="Mês inicial" :options="mesesFiltrado" v-model="mesInicial"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" :min="1998" :label="'Ano final'" :options="anosFiltrado" v-model="anoFinal"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" label="Mês final" :options="mesesFiltrado" v-model="mesFinal"/>
        
            <div class="col-12 d-flex mt-2">
                <b-button variant="success" @click="filtrar()">
                    <i class="fas fa-search mr-2"></i>
                    Filtrar
                </b-button>
                <b-button variant="outline-primary" @click="limpar" class="ml-2">
                    Limpar
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import helpers from "@/common/utils/helpers";
import PessoaService from "../../common/services/pessoa/pessoa.service";
import { AlertasMixin } from "../../common/mixins/AlertasMixin";
export default {
    mixins : [AlertasMixin],
    props : {
        filtro : {
            default : () => {
                return {};
            }
        },
    },
    components : {
        InputSelect
    },
    data : () => ({
        anos : [],
        meses : [],
        pessoas : [],
        projetos : [],
        status : [],    

        projeto : null,
        pessoa : null,
        statusFiltro : null,
        anoInicial : null,
        anoFinal : null,
        mesInicial : null,
        mesFinal : null,
    }),
    mounted(){
        this.inicializar();
    },
    methods : {
        buscarProjetos : function(){
            this.projetos = [
                {text : "Todos", value : null},
            ];
            PessoaService.listarProjetos(this.empresaSelecionada).then(res => {
                this.projetos.push(...res.data.data.map(el => {
                    return {
                        value : el,
                        text : el.nome
                    }
                }));
            });
        },
        buscarPessoas : function(){
            this.pessoas = [
                {text : "Todas", value : null},
            ];
            PessoaService.listar(this.empresaSelecionada).then((result) => {
                result.data.data.itens.sort((a, b) => a.nome.localeCompare(b.nome));
                this.pessoas.push(...result.data.data.itens.map( el => {
                    return {
                        value : el.id,
                        text : el.nome
                    }
                }));
            })
        },
        inicializar : function(){

            this.buscarProjetos();
            this.buscarPessoas();

            this.status = [
                {text : "Todos", value : null, variant : null},
                ...helpers.StatusPropostaProjeto
            ];

            this.meses = [{text : "Todos meses", value : null}, ...helpers.retornarMeses(),];
            let ano = new Date().getFullYear();
            this.anos = [];
            this.anos.push({
                text : "Todos anos",
                value : null,
            });
            for (let index = ano; index >= 1998; index--) {
                this.anos.push(index);            
            }

            this.filtrar();
        },

        filtrar : function(){
            if(this.anoInicial > this.anoFinal){
                this.alertaErro("Ano inicial não pode ser maior que ano final!")
                return;
            }else if(this.anoInicial == this.anoFinal && this.mesInicial > this.mesFinal){
                this.alertaErro("Mês inicial não pode ser maior que o mês final!")
                return;
            }
            let filtro = {
                pessoa : this.pessoa,
                projeto : this.projeto,
                status : this.statusFiltro,
                DataInicio : !this.anoInicial ? null : `${this.anoInicial}-${this.mesInicial}-01`,
                DataFim : !this.anoFinal ? null : `${this.anoFinal}-${this.mesFinal}-01`,
                anoInicio : this.anoInicial,
                anoFinal : this.anoFinal,
                mesInicio : this.mesInicial,
                mesFinal : this.mesFinal,
                pessoaLabel : this.pessoa ? this.pessoas.find(el => el.value == this.pessoa).text : "",
                ProjetoGestaoId : this.projeto ? this.projeto.projetoGestaoId : null,
                ProjetoPDId : this.projeto ? this.projeto.projetoPDId : null,
                projetoLabel : this.projeto ? this.projeto.nome : null

            }
            
            this.$emit('buscar', filtro);
        },

        limpar : function(){
            this.projeto = null;
            this.pessoa = null;
            this.statusFiltro = null;
            this.anoInicial = null;
            this.anoFinal = null;
            this.mesInicial = null;
            this.mesFinal = null;
        },
    },
    watch : {
        filtro : {
            handler : function(){
                this.pessoa = this.filtro.pessoa || null
                this.projeto = this.filtro.projeto || null;
                this.statusFiltro = this.filtro.status || null;
                
                this.anoInicial = this.filtro.DataInicio != null ? this.filtro.DataInicio.split("-")[0] : null;
                this.anoFinal = this.filtro.DataFim != null ? this.filtro.DataFim.split("-")[0] : null;
                this.mesInicial = this.filtro.DataInicio != null ? this.filtro.DataInicio.split("-")[1] : null;
                this.mesFinal = this.filtro.DataFim != null ? this.filtro.DataFim.split("-")[1] : null;
            },
            immediate : true,
        },
        anoInicial : function(valor){
            if(!valor){
                this.mesInicial = null;
                this.mesFinal = null;
                this.anoFinal = null;
                return;
            }

            if(this.anoFinal < valor){
                this.anoFinal = valor;
            }

            if(this.mesInicial == null){
                this.mesInicial = 1;
            }

            if(this.mesFinal == null){
                this.mesFinal = 12;
            }
        },
        anoFinal : function(valor){
            if(this.anoInicial > valor){
                this.anoInicial = valor;
            }
        },
    },
    computed : {
        mesesFiltrado : function(){
            if(this.anoInicial != null){
                return this.meses.filter(el => el.value != null);
            }

            return this.meses;
        },

        anosFiltrado : function(){
            if(this.anoInicial != null){
                return this.anos.filter(el => el != null);
            }

            return this.anos;
        },

        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj ? this.$store.state.app.selectedCompanyObj.id : "";
        }
    }
}
</script>
<style lang="">
    
</style>